<template>
  <div style="width: 100%; height: 100%">
    <div v-show="newTaskProgressShow">
      <NewTaskPlanning
        :userInfo="userInfo"
        :opacityInfos="opacityInfos"
        :numInfos="numInfos"
        :currentProgress="currentProgress"
        :addPermission="addPermission"
        @progressChange="progressChange"
        @newPlan="newPlan"
        @newMissionCountChange="newMissionCountChange"
      ></NewTaskPlanning>
    </div>

    <div v-show="!newTaskProgressShow && !isRoutePlanning">
      <OtherTaskPlanning
        ref="otherTaskPlanning"
        :userInfo="userInfo"
        :opacityInfos="opacityInfos"
        :numInfos="numInfos"
        :selectMissionId="selectMissionId"
        :currentProgress="currentProgress"
        :savePermission="savePermission"
        :editPermission="editPermission"
        :delPermission="delPermission"
        :openTab="openTab"
        @cancelCreactPlan="cancelCreactPlan"
        @progressChange="progressChange"
        @setSelectMissionId="setSelectMissionId"
        @getTaskPlanStatisics="getTaskPlanStatisics"
        @changeIsRoutePlanning="changeIsRoutePlanning"
      ></OtherTaskPlanning>
    </div>

    <RoutePlanning
      ref="routePlanning"
      :userInfo="userInfo"
      :startEndPlanPointTableData="startEndPlanPointTableData"
      @changeIsRoutePlanning="changeIsRoutePlanning"
      v-show="!newTaskProgressShow && isRoutePlanning"
    ></RoutePlanning>
  </div>
</template>

<script type="text/javascript">
import NewTaskPlanning from "./NewTaskPlanning";
import OtherTaskPlanning from "./OtherTaskPlanning";
import RoutePlanning from "./RoutePlanning";

const opacity1 = "opacity: 1;";
const opacity04 = "opacity: 0.4;";

const newTaskProgress = "newTaskProgress";
const planningProgress = "planningProgress";
const submittedProgress = "submittedProgress";
const rejectedProgress = "rejectedProgress";

export default {
  name: "TaskPlanning",
  props: ["userInfo", "menuId"],
  data() {
    return {
      currentProgress: "currentProgress",
      opacityInfos: {
        opacityOfNewTask: opacity1,
        opacityOfPlanning: opacity04,
        opacityOfSubmitted: opacity04,
        opacityOfRejected: opacity04,
      },
      openTab: newTaskProgress,
      numInfos: {
        newTaskNum: 0,
        planningNum: 0,
        submittedNum: 0,
        rejectedNum: 0,
      },
      selectMissionId: null,
      isRoutePlanning: false,
      addPermission: null, //创建计划权限
      savePermission: null, //提交权限
      editPermission: null, //修改权限
      delPermission: null, //删除权限

      startEndPlanPointTableData: [], // 航路规划 线路
    };
  },
  methods: {
    progressChange(name) {
      if (this.openTab !== name) {
        if (name == newTaskProgress) {
          this.newTask();
        } else if (name == planningProgress) {
          this.planning();
        } else if (name == submittedProgress) {
          this.submitted();
        } else if (name == rejectedProgress) {
          this.rejected();
        }
      }
      this.openTab = name;
    },
    newMissionCountChange(count) {
      this.$data.numInfos.newTaskNum = count;
    },
    getTaskPlanStatisics() {
      this.getRequest("/uav-task-server/flight/queryFlightStaticByStatus.do").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              this.$data.numInfos.planningNum = data.waitingforapprove;
              this.$data.numInfos.submittedNum = data.approved;
              this.$data.numInfos.rejectedNum = data.rejected;
            } else {
              this.$data.numInfos.planningNum = 0;
              this.$data.numInfos.submittedNum = 0;
              this.$data.numInfos.rejectedNum = 0;
            }
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>啊哦,统计信息获取失败~";
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "confirmClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm",
              showCancelButton: false,
            });
          }
        }
      );
    },
    changeIsRoutePlanning(data) {
      this.startEndPlanPointTableData = data.startEndPlanPointTableData
      this.isRoutePlanning = data.show;
      this.showRoutePlanning(data.id, data.routeId);
      if (!this.isRoutePlanning) {
        this.$refs.otherTaskPlanning.getHistoryAirLines();
      }
    },
    showRoutePlanning(id, routeId) {
      if (this.isRoutePlanning) {
        this.$nextTick(function () {
          this.$refs.routePlanning.init(id, routeId);
        });
      }
    },
    newPlan(missionId) {
      this.$set(this.$data, "selectMissionId", missionId);
      this.$refs.otherTaskPlanning.newEmptyPlan(missionId);
      this.planning();
    },
    cancelCreactPlan() {
      this.newTask();
    },
    newTask() {
      this.$data.opacityInfos.opacityOfNewTask = opacity1;
      this.$data.opacityInfos.opacityOfPlanning = opacity04;
      this.$data.opacityInfos.opacityOfSubmitted = opacity04;
      this.$data.opacityInfos.opacityOfRejected = opacity04;
      this.$data.currentProgress = newTaskProgress;
    },
    planning() {
      this.$data.opacityInfos.opacityOfNewTask = opacity04;
      this.$data.opacityInfos.opacityOfPlanning = opacity1;
      this.$data.opacityInfos.opacityOfSubmitted = opacity04;
      this.$data.opacityInfos.opacityOfRejected = opacity04;
      this.$data.currentProgress = planningProgress;
    },
    submitted() {
      this.$data.opacityInfos.opacityOfNewTask = opacity04;
      this.$data.opacityInfos.opacityOfPlanning = opacity04;
      this.$data.opacityInfos.opacityOfSubmitted = opacity1;
      this.$data.opacityInfos.opacityOfRejected = opacity04;
      this.$data.currentProgress = submittedProgress;
    },
    rejected() {
      this.$data.opacityInfos.opacityOfNewTask = opacity04;
      this.$data.opacityInfos.opacityOfPlanning = opacity04;
      this.$data.opacityInfos.opacityOfSubmitted = opacity04;
      this.$data.opacityInfos.opacityOfRejected = opacity1;
      this.$data.currentProgress = rejectedProgress;
    },
    setSelectMissionId(missionId) {
      this.$set(this.$data, "selectMissionId", missionId);
    },
    getButtonList(buttonList) {
      buttonList.forEach((button) => {
        this.getChildren(button);
      });
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "taskPlanning-add") {
              this.addPermission = child;
            } else if (child.path === "taskPlanning-save") {
              this.savePermission = child;
            } else if (child.path === "taskPlanning-edit") {
              this.editPermission = child;
            } else if (child.path === "taskPlanning-del") {
              this.delPermission = child;
            }
          }
        }
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
  },
  mounted() {
    this.addPermission = null;
    this.savePermission = null;
    this.editPermission = null;
    this.delPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);

    this.$set(this.$data, "currentProgress", newTaskProgress);
    this.getTaskPlanStatisics();
    if (!window.queryTaskPlanStatisicsTimer) {
      window.queryTaskPlanStatisicsTimer = setInterval(this.getTaskPlanStatisics, 30000); //30秒轮询一次
    }
  },
  computed: {
    newTaskProgressShow() {
      return this.$data.currentProgress == "newTaskProgress";
    },
  },
  components: { NewTaskPlanning, OtherTaskPlanning, RoutePlanning },
  watch: {},
  beforeDestroy() {
    if (window.queryTaskPlanStatisicsTimer) {
      clearInterval(window.queryTaskPlanStatisicsTimer);
      window.queryTaskPlanStatisicsTimer = null;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/taskplan/TaskPlanning.vue